import { Button } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import { LinkAudienceKind, LinkPermission } from "./common";
import styles from "./DefaultLinkConfigurationSection.module.less";
import { LinkIcon } from "./LinkIcon";
import { linkDescriptionToLocalizationKeyMap } from "./SharedLink";

export type DefaultLinkConfigurationSectionProps = {
	audience: LinkAudienceKind;
	allowEditing: boolean;
	onChangeSettings: () => void;
};

export const DefaultLinkConfigurationSection = (props: DefaultLinkConfigurationSectionProps): ReactElement => {
	const {
		audience,
		allowEditing,
		onChangeSettings
	} = props;

	const permission: LinkPermission = allowEditing
		? LinkPermission.CanEdit
		: LinkPermission.CanView;

	return (
		<div className={styles.root}>
			<LinkIcon
				kind={audience}
			/>
			<p className={styles.description}>
				{localize(linkDescriptionToLocalizationKeyMap[audience][permission])}
			</p>
			<Button
				kind="transparent"
				icon="gear"
				text={localize("_ChangeSettings")}
				onClick={onChangeSettings}
				trackingId="change-settings"
			/>
		</div>
	);
};
DefaultLinkConfigurationSection.displayName = "DefaultLinkConfigurationSection";
